import {Component} from '@angular/core';
import {LoadingPage} from '../../../shared/components/loading/loading.page.component';
import {ProfileService} from '../profile/profile.service';
import {Router} from '@angular/router';

@Component({
  selector: 'itpx-pprivacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.css']
})
export class PrivacyPolicyComponent extends LoadingPage {
  public privacyPolicy: string;
  public lastUpdate: any;

  constructor(
    private profileService: ProfileService,
    private router: Router
  ) {
    super();
  }

  ngOnInit() {
    this.profileService.loadPrivacyPolicy()
      .subscribe(policy => {
      this.privacyPolicy = policy.data.content;
      this.lastUpdate = policy.data.updatedAt;
      this.ready();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/privacy-policy/privacy-policy.component.ts